export default __webpack_public_path__ + "static/media/640_dummy2016-apotheke01-mobile-de.507968aa.png";